/**
 * Free shipping progress bar — client-side sync.
 * Added 10 Aug 2026.
 *
 * The Liquid-rendered [data-free-shipping-bar] in snippets/cart-free-shipping-bar.liquid
 * gives correct first-paint content, but this theme rebuilds the cart drawer/page
 * client-side after add-to-cart or a quantity change (theme.js theme.AjaxProduct /
 * theme.CartForm), and that rebuild never touches this node. This file listens for
 * the same events the theme already dispatches and recomputes the bar itself from
 * a fresh /cart.js call, independent of theme.js internals — deliberately kept out
 * of theme.js so it doesn't risk that (large, shared-everywhere) file.
 */
(function () {
  'use strict';

  function formatMoney(cents) {
    var amount = (Math.round(cents) / 100).toFixed(2);
    return '£' + amount;
  }

  function renderBarContent(container, cart) {
    var thresholdCents = parseInt(container.getAttribute('data-free-shipping-threshold'), 10);

    if (!thresholdCents || !cart || cart.item_count === 0) {
      container.innerHTML = '';
      return;
    }

    var remainingCents = thresholdCents - cart.total_price;
    var percent = (cart.total_price * 100) / thresholdCents;
    if (percent > 100) percent = 100;
    if (percent < 0) percent = 0;

    var messageHTML;
    if (remainingCents > 0) {
      messageHTML = '<p class="cart__free-shipping-message">Add ' +
        formatMoney(remainingCents) + ' more for free UK shipping</p>';
    } else {
      messageHTML = '<p class="cart__free-shipping-message cart__free-shipping-message--unlocked">' +
        '&#10003; You&#8217;ve unlocked free UK shipping</p>';
    }

    container.innerHTML = messageHTML +
      '<div class="cart__free-shipping-track">' +
      '<div class="cart__free-shipping-fill" style="width: ' + percent + '%;"></div>' +
      '</div>';
  }

  function updateAllBars(cart) {
    var containers = document.querySelectorAll('[data-free-shipping-bar]');
    for (var i = 0; i < containers.length; i++) {
      renderBarContent(containers[i], cart);
    }
  }

  function refreshFromServer() {
    if (!document.querySelector('[data-free-shipping-bar]')) {
      return;
    }
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(updateAllBars)
      .catch(function () {});
  }

  // Add-to-cart success (theme.AjaxProduct) and quantity-change success
  // (theme.CartForm.quantityChanged) both eventually need this refreshed.
  document.addEventListener('ajaxProduct:added', refreshFromServer);
  document.addEventListener('cart:updated', function (evt) {
    if (evt.detail && evt.detail.cart) {
      updateAllBars(evt.detail.cart);
    } else {
      refreshFromServer();
    }
  });

  // Belt-and-braces: whenever the drawer opens, make sure the bar reflects
  // whatever's actually in the cart right now.
  document.addEventListener('cart:open', refreshFromServer);
})();
